import { ApolloLink } from './ApolloLink';

export const execute = ApolloLink.execute;
